export default "__VITE_ASSET__17a0e2c9__"